var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.625V17.5C15 18.8807 13.8807 20 12.5 20H2.5C1.11929 20 0 18.8807 0 17.5V2.5C0 1.11929 1.11929 0 2.5 0H9.375L15 5.625ZM11.25 5.625C10.2145 5.625 9.375 4.78553 9.375 3.75V1.25H2.5C1.80964 1.25 1.25 1.80964 1.25 2.5V17.5C1.25 18.1904 1.80964 18.75 2.5 18.75H12.5C13.1904 18.75 13.75 18.1904 13.75 17.5V5.625H11.25Z",
    fill: "#4A5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPaper);
export default __webpack_public_path__ + "static/media/ico-paper.325546317dea8ed4b891a644b1581342.svg";
export { ForwardRef as ReactComponent };